module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/pl-card-drag.558f8bd03bfc1a5551af.gif";